<template>
  <aside class="flex-none">
    <!-- Desktop Sidebar -->
    <div class="fixed hidden md:flex flex-col bg-white top-[60px] w-48 h-[calc(100vh-60px)] p-4 gap-2 border-r border-gray-200 overflow-y-auto z-50">
        <div>
        <router-link 
          :to="{ name: 'Home' }" 
          class="flex items-center gap-1 text-gray-700 px-4 py-3 text-sm font-medium transition-colors hover:bg-gray-100 rounded-lg"
          active-class="bg-red-50 text-[#DC2626]"
        >
          <i class="fa-solid fa-house w-8 text-center"></i>
          <span>Home</span>
        </router-link>

        <router-link 
          :to="{ name: 'Matches' }" 
          class="flex items-center gap-1 text-gray-700 px-4 py-3 text-sm font-medium transition-colors hover:bg-gray-100 rounded-lg"
          active-class="bg-red-50 text-[#DC2626]"
        >
          <i class="fa-regular fa-circle-question w-8 text-center"></i>
          <span>Matches</span>
        </router-link>

        <router-link 
          :to="{ name: 'ChatPage' }" 
          class="flex items-center gap-1 text-gray-700 px-4 py-3 text-sm font-medium transition-colors hover:bg-gray-100 rounded-lg"
          active-class="bg-red-50 text-[#DC2626]"
        >
          <i class="fa-solid fa-arrows-up-down-left-right w-8 text-center"></i>
          <span>Chats</span>
        </router-link>
        </div>

        <div class="mt-4 pt-5 border-t border-gray-100"></div>

        <div class="flex-1"></div>
        
        <div class="pt-10 flex flex-col bg-white">
           <router-link 
            :to="{ name: 'Getapp' }" 
            class="flex mb-2 px-6 py-2.5 items-center gap-1 bg-red-600 text-white text-sm font-black rounded-xl hover:bg-red-500 transition-colors shadow-[0_0_15px_rgba(239,68,68,0.2)]"
            active-class="bg-red-50 text-[#DC2626]"
          >
            <img src="@/assets/logo.png" width="25" height="25" class="w-8 object-contain">
            <span>Get App</span>
          </router-link>

          <router-link 
            :to="{ name: 'PaymentPage' }" 
            class="flex items-center gap-1 text-gray-700 px-4 py-3 text-sm font-medium transition-colors hover:bg-gray-100 rounded-lg"
            active-class="bg-red-100 text-[#DC2626]"
          >
            <i class="fa-solid fa-credit-card w-8 text-center"></i>
            <span>Payment</span>
          </router-link>

          <router-link 
            :to="{ name: 'About' }" 
            class="flex items-center gap-1 text-gray-700 px-4 py-3 text-[12px] font-medium transition-colors hover:bg-gray-100 rounded-lg"
            active-class="bg-red-50 text-[#DC2626]"
          >
            <img src="@/assets/logo.png" width="25" height="25" class="w-8 object-contain">
            <span>About Secrable</span>
          </router-link>

          <router-link 
            :to="{ name: 'ContactUs' }" 
            class="flex items-center gap-1 text-gray-700 px-4 py-3 text-[12px] font-medium transition-colors hover:bg-gray-100 rounded-lg"
            active-class="bg-red-50 text-[#DC2626]"
          >
            <i class="fa-solid fa-phone w-8 text-center"></i>
            <span>Contact</span>
          </router-link>
        </div>

        <div class="p-4 border-t border-gray-100">
            <div class="text-[11px] text-gray-400 text-center">
                © 2026 Secrable Inc. All rights reserved.
                <span>
                  <router-link :to="{ name: 'dashbord' }" class="text-white/80 text-[12px] font-medium transition-colors">
                <span>_</span>
              </router-link>
                </span>
            </div>
        </div>
    </div>

    <!-- Mobile Menu Overlay -->
    <Teleport to="body">
      <Transition name="fade">
        <div v-if="uiStore.isMobileMenuOpen" 
             @click="uiStore.closeMobileMenu()"
             class="md:hidden fixed inset-0 bg-black/60 z-[2000] backdrop-blur-sm">
        </div>
      </Transition>
      <Transition name="slide">
        <div v-if="uiStore.isMobileMenuOpen" 
             class="md:hidden fixed top-0 left-0 h-full w-[280px] bg-white z-[2001] shadow-2xl border-r border-gray-200 flex flex-col transition-colors duration-300">
            <!-- Header for mobile menu -->
            <div class="flex items-center h-[60px] px-4 border-b border-gray-200">
                <button @click="uiStore.closeMobileMenu()" class="p-2 text-gray-700 hover:bg-gray-100 rounded-lg">
                    <i class="fa-solid fa-xmark text-xl"></i>
                </button>
                <div class="flex items-center gap-2 ml-2">
                    <img src="@/assets/logo.png" width="32" height="32" alt="Logo">
                    <span class="text-lg font-bold text-[#DC2626]">Secrable</span>
                </div>
            </div>

            <div class="p-4 space-y-2 flex-1 overflow-y-auto bg-white">
                <router-link 
                    @click="uiStore.closeMobileMenu()"
                    :to="{ name: 'Home' }" 
                    class="flex items-center gap-1 text-gray-700 px-4 py-3 text-[12px] font-medium transition-colors hover:bg-gray-100 rounded-lg"
                    active-class="bg-red-50 text-[#DC2626]"
                >
                    <i class="fa-solid fa-house w-6 text-center"></i>
                    <span>Home</span>
                </router-link>

                <router-link 
                    @click="uiStore.closeMobileMenu()"
                    :to="{ name: 'Matches' }" 
                    class="flex items-center gap-1 text-gray-700 px-4 py-3 text-[12px] font-medium transition-colors hover:bg-gray-100 rounded-lg"
                    active-class="bg-red-50 text-[#DC2626]"
                >
                    <i class="fa-regular fa-circle-question w-6 text-center"></i>
                    <span>Matches</span>
                </router-link>

                <router-link 
                    @click="uiStore.closeMobileMenu()"
                    :to="{ name: 'ChatPage' }" 
                    class="flex items-center gap-1 text-gray-700 px-4 py-3 text-[12px] font-medium transition-colors hover:bg-gray-100 rounded-lg"
                    active-class="bg-red-50 text-[#DC2626]"
                >
                    <i class="fa-solid fa-arrows-up-down-left-right w-6 text-center"></i>
                    <span>Chats</span>
                </router-link>

                <div class="flex-1"></div>

                <div class="pt-4 border-t border-gray-100 bg-white">
                  <router-link 
                        @click="uiStore.closeMobileMenu()"
                        :to="{ name: 'Getapp' }" 
                        class="flex items-center gap-1 text-gray-700 px-4 py-3 text-[12px] font-medium transition-colors hover:bg-gray-100 rounded-lg"
                        active-class="bg-red-50 text-[#DC2626]"
                    >
                        <i class="fa-solid fa-credit-card w-6 text-center"></i>
                        <span>Get App</span>
                    </router-link>  
                  <router-link 
                        @click="uiStore.closeMobileMenu()"
                        :to="{ name: 'PaymentPage' }" 
                        class="flex items-center gap-1 text-gray-700 px-4 py-3 text-[12px] font-medium transition-colors hover:bg-gray-100 rounded-lg"
                        active-class="bg-red-50 text-[#DC2626]"
                    >
                        <i class="fa-solid fa-credit-card w-6 text-center"></i>
                        <span>Payment</span>
                    </router-link>

                    <router-link 
                        @click="uiStore.closeMobileMenu()"
                        :to="{ name: 'ContactUs' }" 
                        class="flex items-center gap-1 text-gray-700 px-4 py-3 text-[12px] font-medium transition-colors hover:bg-gray-100 rounded-lg"
                        active-class="bg-red-50 text-[#DC2626]"
                    >
                        <i class="fa-solid fa-phone w-6 text-center"></i>
                        <span>Contact</span>
                    </router-link>
                </div>
            </div>
            
            <div class="p-4 border-t border-gray-200 bg-white">
                <div class="text-[11px] text-gray-400 text-center">
                    © 2026 Secrable Inc. All rights reserved.
                </div>
            </div>
        </div>
      </Transition>
    </Teleport>
  </aside>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.slide-enter-active, .slide-leave-active { transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
.slide-enter-from { transform: translateX(-100%); }
.slide-leave-to { transform: translateX(-100%); }

.slide-down-enter-active, .slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>

<script setup>
import { useUiStore } from '@/Stores/ui';
const uiStore = useUiStore();
</script>

<script>
export default {
  name: 'MenuComponent'
}
</script>
